import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新規生徒を追加")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_7 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_10 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_11 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " この生徒のプロンプト作成を禁止する ", -1)
const _hoisted_13 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_14 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " この生徒から先生へのメッセージ送信を許可する ", -1)
const _hoisted_16 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_17 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  for: "classSchedules",
  class: "leading-7 text-sm text-gray-600 w-full"
}, [
  /*#__PURE__*/_createTextVNode(" 保護者向け入退室通知受信メール "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "※登録前に保護者に確認が必要です")
], -1)
const _hoisted_19 = { class: "flex w-full h-full" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "メールアドレスを追加する", -1)
const _hoisted_23 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", {
  for: "classSchedules",
  class: "leading-7 text-sm text-gray-600 w-full"
}, " 毎週の授業日時 ", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_26 = { class: "w-full flex items-end" }
const _hoisted_27 = { class: "w-1/4" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " 曜日 ", -1)
const _hoisted_29 = { class: "relative transition-all duration-300 hover:text-primary-500" }
const _hoisted_30 = /*#__PURE__*/_createVNode("option", { disabled: "" }, "授業曜日を選択", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "absolute right-2 top-0 h-full w-6 text-center pointer-events-none flex items-center justify-center text-primary-500" }, [
  /*#__PURE__*/_createVNode("svg", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    class: "w-4 h-4",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M6 9l6 6 6-6" })
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_33 = { class: "w-1/4" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " 開始 ", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "w-1/6 text-center py-2" }, "〜", -1)
const _hoisted_36 = { class: "w-1/4" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " 終了 ", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", null, "授業日時を追加", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 生徒を登録 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_multi_select_box = _resolveComponent("m-multi-select-box")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "ユーザーネーム",
          name: "name",
          type: "text",
          placeholder: "例）田中（た） ※学習室などで、他ユーザに表示される可能性があります",
          value: _ctx.name,
          invalid: !_ctx.validName,
          "invalid-message": "ユーザーネームは入力必須です",
          entered: _ctx.enteredName,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
          onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enteredName = true))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_select_box, {
          key: "ref.id",
          label: "教室",
          name: "classroom",
          placeholder: "所属教室を選択",
          options: _ctx.classRooms,
          value: _ctx.selectClassroomId,
          "value-key": "ref.id",
          "text-key": "data.name",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectClassroomId = $event))
        }, null, 8, ["options", "value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_m_text_field, {
          label: "生徒ID ※自動生成されます(編集不可)",
          name: "studentId",
          type: "text",
          value: _ctx.studentId,
          disabled: ""
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "ログインID (重複不可)",
          name: "studentLoginId",
          type: "text",
          placeholder: "半角英数字5文字以上",
          value: _ctx.studentLoginId,
          invalid: !_ctx.validstudentLoginId,
          "invalid-message": "IDは半角英数字5文字以上で入力してください。また他の生徒と同じIDは使用できません。",
          entered: "",
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.studentLoginId = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_m_text_field, {
          label: "ログインパスワード",
          name: "password",
          type: "text",
          placeholder: "半角英数字記号8文字以上",
          value: _ctx.password,
          invalid: !_ctx.validPassword,
          "invalid-message": "パスワードは8〜64文字で、英字と、数字または記号を含めてください（スペースと全角文字は使えません）",
          entered: "",
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.password = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_m_select_box, {
          label: "学年",
          name: "grade",
          placeholder: "生徒の学年を選択",
          options: _ctx.grades,
          value: _ctx.selectGrade,
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectGrade = $event))
        }, null, 8, ["options", "value"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_m_text_area, {
          label: "特徴",
          name: "characteristics",
          placeholder: "生徒の特徴を記述してください（任意）",
          value: _ctx.characteristic,
          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.characteristic = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_m_text_field, {
          label: "Googleアカウント",
          name: "gmail",
          placeholder: "生徒のGmailを入力してください（任意）",
          value: _ctx.gmail,
          invalid: !_ctx.validGmail,
          "invalid-message": "メールアドレスが正しくありません",
          entered: "",
          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.gmail = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_m_text_field, {
          label: "Microsoftアカウント",
          name: "microsoftEmail",
          placeholder: "生徒のMicrosoftメールを入力してください（任意）",
          value: _ctx.microsoftEmail,
          invalid: !_ctx.validMicrosoftEmail,
          "invalid-message": "メールアドレスが正しくありません",
          entered: "",
          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.microsoftEmail = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _withDirectives(_createVNode("input", {
            id: "allow-students-to-create-prompts",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isPromptCreationDisabled = $event)),
            type: "checkbox",
            name: "allow-students-to-create-prompts",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.isPromptCreationDisabled]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode("div", _hoisted_16, [
          _withDirectives(_createVNode("input", {
            id: "allow-student-message-sending",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isStudentMessageSendingAllowed = $event)),
            type: "checkbox",
            name: "allow-student-message-sending",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.isStudentMessageSendingAllowed]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.emailReceivers, (emailReceiver, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "w-full flex flex-col items-center rounded-md border-2 border-gray-200 px-3 py-2 mb-4"
          }, [
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_m_text_field, {
                modelValue: emailReceiver.email,
                "onUpdate:modelValue": ($event: any) => (emailReceiver.email = $event),
                label: "メールアドレス",
                name: "email",
                type: "email",
                placeholder: "example@mingaku.net",
                invalid: !_ctx.validEmail(emailReceiver.email),
                "invalid-message": "メールアドレスが正しくありません",
                entered: _ctx.enteredEmail[i],
                value: emailReceiver.email,
                onInput: ($event: any) => (emailReceiver.email = $event),
                onEnter: ($event: any) => (_ctx.enteredEmail[i] = true),
                class: "flex-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid", "entered", "value", "onInput", "onEnter"]),
              _createVNode(_component_m_button, {
                color: "primary-500 ml-3 h-7 mt-9",
                "hover-color": "primary-600",
                onClick: ($event: any) => (_ctx.deleteEmailReceiver(i))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, { type: "trash" }),
                  _hoisted_20
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createVNode("div", {
          class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addEmailReceiver && _ctx.addEmailReceiver(...args)))
        }, [
          _hoisted_21,
          _hoisted_22
        ])
      ]),
      _createVNode("div", _hoisted_23, [
        _hoisted_24,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.classSchedules, (schedule, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "w-full flex flex-col items-center rounded-md border-2 border-gray-200 px-3 py-2 mb-4"
          }, [
            _createVNode(_component_m_button, {
              color: "primary-500",
              "hover-color": "primary-600",
              size: "sm",
              onClick: ($event: any) => (_ctx.deleteSchedule(i))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_m_icon, {
                  type: "trash",
                  class: "mr-2"
                }),
                _hoisted_25
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode("div", _hoisted_29, [
                  _withDirectives(_createVNode("select", {
                    "onUpdate:modelValue": ($event: any) => (schedule.weekday = $event),
                    class: "w-full border-b-2 border-gray-200 appearance-none pt-1 pb-2 px-3 focus:outline-none hover:border-primary-600 cursor-pointer"
                  }, [
                    _hoisted_30,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weekdays, (weekday) => {
                      return (_openBlock(), _createBlock("option", {
                        key: weekday,
                        selected: schedule.weekday == weekday
                      }, _toDisplayString(weekday), 9, ["selected"]))
                    }), 128))
                  ], 8, ["onUpdate:modelValue"]), [
                    [_vModelSelect, schedule.weekday]
                  ]),
                  _hoisted_31
                ])
              ]),
              _hoisted_32,
              _createVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (schedule.start = $event),
                  type: "time",
                  name: "start",
                  placeholder: "00:00",
                  class: "w-full border-b-2 border-gray-200 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300"
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, schedule.start]
                ])
              ]),
              _hoisted_35,
              _createVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (schedule.end = $event),
                  type: "time",
                  name: "start",
                  placeholder: "00:00",
                  class: "w-full border-b-2 border-gray-200 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300"
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, schedule.end]
                ])
              ])
            ])
          ]))
        }), 128)),
        _createVNode("div", {
          class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addClassSchedule && _ctx.addClassSchedule(...args)))
        }, [
          _hoisted_38,
          _hoisted_39
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.propertyDatas, (data, i) => {
        return (_openBlock(), _createBlock("div", {
          key: data.property.ref.id,
          class: "relative w-3/4 mx-auto mb-6",
          style: { zIndex: _ctx.propertyDatas.length - i }
        }, [
          (data.property.data.type == 'string')
            ? (_openBlock(), _createBlock(_component_m_text_field, {
                key: 0,
                label: data.property.data.title,
                name: data.property.ref.id,
                type: "text",
                placeholder: "テキストを入力",
                value: data.value,
                invalid: data.value.length == 0,
                onInput: ($event: any) => (_ctx.propertyDatas[i].value = $event)
              }, null, 8, ["label", "name", "value", "invalid", "onInput"]))
            : (data.property.data.type == 'number')
              ? (_openBlock(), _createBlock(_component_m_text_field, {
                  key: 1,
                  label: data.property.data.title,
                  name: data.property.ref.id,
                  type: "number",
                  placeholder: "数字を入力",
                  value: data.value,
                  invalid: data.value.length == 0,
                  onInput: ($event: any) => (_ctx.propertyDatas[i].value = $event)
                }, null, 8, ["label", "name", "value", "invalid", "onInput"]))
              : (
            data.property.data.type == 'select' && !data.property.data.multiple
          )
                ? (_openBlock(), _createBlock(_component_m_select_box, {
                    key: 2,
                    label: data.property.data.title,
                    name: data.property.ref.id,
                    placeholder: "選択してください",
                    options: data.property.data.choices,
                    value: data.value,
                    onChange: ($event: any) => (_ctx.propertyDatas[i].value = $event)
                  }, null, 8, ["label", "name", "options", "value", "onChange"]))
                : (
            data.property.data.type == 'select' && data.property.data.multiple
          )
                  ? (_openBlock(), _createBlock(_component_m_multi_select_box, {
                      key: 3,
                      label: data.property.data.title,
                      name: data.property.ref.id,
                      placeholder: 
            data.property.data.choices.filter(c =>
              (Array.isArray(data.value)
                ? data.value
                : [data.value.toString()]
              ).includes(c)
            ).length > 0
              ? data.property.data.choices
                  .filter(c =>
                    (Array.isArray(data.value)
                      ? data.value
                      : [data.value.toString()]
                    ).includes(c)
                  )
                  .join(', ')
              : '選択してください'
          ,
                      options: data.property.data.choices,
                      values: 
            Array.isArray(data.value) ? data.value : [data.value.toString()]
          ,
                      "force-scoped-id": "",
                      onChange: ($event: any) => (_ctx.updateMultiSelectValue(i, $event))
                    }, null, 8, ["label", "name", "placeholder", "options", "values", "onChange"]))
                  : _createCommentVNode("", true)
        ], 4))
      }), 128))
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.registerStudent
      }, {
        default: _withCtx(() => [
          _hoisted_40
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}